import { useEffect, useState } from "react";
import {
  DisplayResultMessage,
  LanguageNameSpaces,
  OpenMessage,
} from "@shared/types";
import { sharedLib } from "@shared/services/shared.service";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface useLiveGroupSearchModalProps {
  onCancel?: () => void;
  displayResultMessage: DisplayResultMessage;
  openMessage: OpenMessage;
  openModalMessage?: OpenMessage;
}

const useLiveGroupSearchModal = ({
  onCancel,
  displayResultMessage,
  openMessage,
  openModalMessage: propsOpenModalMessage,
}: useLiveGroupSearchModalProps) => {
  const [searchValue, setSearchValue] = useState("");
  const [liveUpdateChannels, { isFetching: liveUpdateChannelsFetching }] =
    sharedLib.sharedApi.configuration.useLazyLiveUpdateChannelsQuery();
  const [searchClicked, setSearchClicked] = useState(false);
  const openModalMessage = propsOpenModalMessage ?? openMessage;
  const { t } = useTypedTranslation(LanguageNameSpaces.GROUPS);

  useEffect(() => {
    if (searchClicked && searchClicked) {
      setSearchClicked(false);
    }
  }, [searchValue]);

  const handleLiveUpdate = () => {
    if (!searchValue) {
      setSearchClicked(true);
      return;
    }

    displayResultMessage(
      liveUpdateChannels({ text_contained: searchValue }).unwrap(),
      undefined,
      t("live_search.no_match"),
      undefined,
      undefined,
      undefined,
      false
    ).then((response) => {
      const groupsData = response.data?.data?.groups_data;
      if (!response.message && !groupsData?.length) {
        openModalMessage(t("live_search.no_match"), "warning");
      } else if (groupsData?.length) {
        const message = t("live_search.success");
        if (onCancel) {
          onCancel();
          openMessage(message, "success");
        } else {
          openModalMessage(message, "success");
        }
      } else if (response.message) {
        openModalMessage(response.message, "warning");
      }
    });
  };

  const searchInputProps = {
    onChange: setSearchValue,
    placeholder: t("live_search.placeholder"),
  };

  return {
    searchInputProps,
    errorMessage:
      searchClicked && !searchValue && t("live_search.input_required"),
    handleLiveUpdate,
    isLoading: liveUpdateChannelsFetching,
    modalTitle: t("live_search.title"),
    description: t("live_search.description"),
  };
};

export default useLiveGroupSearchModal;
